<template>
  <div class="component-wrap" :class="{'component-padded' : base.padded, 'active': active}">
    <div class="current-active"></div>
    <div v-if="base.title" class="component-header">
      <div class="component-title">
        <div>{{base.title}}</div>
        <div class="subtitle">{{base.subtitle}}</div>
      </div>
      <div class="component-more">
        <div class="three-dot"></div>
      </div>
    </div>
    <div class="component-body with-padding">
      <div class="grid-goods out-padding" :class="config.style === 'grids' ? 'three-inrow' : 'two-inrow'">
        <div v-for="(item, index) in data" :key="index" class="grid-item">
          <div class="goods-wrap">
            <div class="thumbnail">
              <img class="goods-img" :src="wximageurl + item.imgUrl" />
            </div>
            <div class="caption">
              <img class="goods-brand" v-if="config.brand && config.style !== 'grids'" :src="item.brand ? wximageurl + item.brand : 'https://fakeimg.pl/60x60/EFEFEF/CCC/?text=brand&font=lobster'" />
              <div class="goods-title">{{item.title}}</div>
              <div v-if="config.showPrice" class="price"><span class="cur">¥</span>{{item.price/100}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      res: {
        type: Object,
        default: {}
      },
      active: {
        type: Boolean,
        default: false
      }
    },
    watch: {
      res: {
        deep: true,
        handler (value) {
          if (value) {
            this.setData(value)
          }
        }
      }
    },
    data () {
      return {
        base: {},
        config: {},
        data: []
      }
    },
    methods: {
      setData(val) {
        this.base = val.base
        this.config = val.config
        this.data = val.data
      }
    },
    mounted() {
      this.setData(this.res)
    }
  }
</script>

<style scoped lang="scss">
  .grid-goods {
    display: flex;
    flex-wrap: wrap;
    &.out-padding {
      margin: 0 -3px;
    }
    &.two-inrow .grid-item {
      width: 50%;
    }
    &.three-inrow .grid-item {
      width: 33.33333%;
    }
    .grid-item {
      padding: 3px;
      .goods-wrap {
        border-radius: 6px;
        border: 1px solid #f5f5f5;
        .thumbnail {
          position: relative;
          &::after {
            display: flex;
            padding-top: 100%;
            content: "";
          }
          .goods-img {
            display: block;
            position: absolute;
            width: 100%;
            height: 100%;
          }
        }
        .caption {
          position: relative;
          padding: 0 10px 10px 10px;
          .goods-brand {
            display: block;
            width: 60px;
            height: 60px;
            margin-left: auto;
            margin-right: auto;
            margin-top: -25px;
            margin-bottom: 5px;
            border-radius: 50%;
          }
          .goods-title {
            display: -webkit-box;
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            height: 30px;
            margin-top: 5px;
            line-height: 1.4;
            font-size: 12px;
          }
          .price {
            color: #fc511f;
          }
          .cur {
            font-size: 10px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// goods_grid.vue?bb8de810